import * as React from "react";
import { EJIServiceFormValue } from "./JobDetailsForm";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import { AddPartSection } from "./AddPartSection";
import { StyledHR } from "./UpdateServiceDetailsFormSection/StyledHR";
import { FeeItemSection } from "./UpdateServiceDetailsFormSection/FeeItemSection";
import { PartItemSection } from "./UpdateServiceDetailsFormSection/PartItemSection";
import { isEjiServiceFormValueValid } from "./UpdateServiceDetailsFormSection/isEjiServiceFormValueValid";
import { isEmpty } from "ramda";
import { PossibleEjiService } from "../../generated/nest-graphql";

export const UpdateServiceDetailsFormSection: React.FC<{
  editedService: EJIServiceFormValue;
  setEditedServiceAndRecalculatePrice: any;
  servicesList: PossibleEjiService[];
  useMultiplePartOrders?: boolean;
}> = ({ editedService, setEditedServiceAndRecalculatePrice, servicesList, useMultiplePartOrders }) => {
  const filteredParts = editedService?.items.filter((product) => product?.category === "Part");
  const customerPriceText =
    !isEjiServiceFormValueValid(editedService, servicesList) && !isEmpty(editedService)
      ? "--"
      : String(editedService.customerPrice ?? 0.0);

  return (
    <div>
      <div className="text-xl font-bold mb-1">Customer Price ${customerPriceText}</div>
      <div className="mb-8">
        <InputLabel shrink className="mb-1">
          Service Name
        </InputLabel>
        <Typography className="pb-2">{editedService?.name}</Typography>
        <StyledHR />
      </div>
      {editedService?.items?.map((item, itemIdx) => (
        <div className={"grid grid-cols-1 gap-4"} key={itemIdx}>
          {item?.category === "Part" && (
            <PartItemSection
              editedService={editedService}
              setEditedServiceAndRecalculatePrice={setEditedServiceAndRecalculatePrice}
              item={item}
              itemIdx={itemIdx}
              filteredParts={filteredParts}
              useMultiplePartOrders={useMultiplePartOrders}
            ></PartItemSection>
          )}
          {item?.category === "Fee" && (
            <FeeItemSection
              editedService={editedService}
              setEditedServiceAndRecalculatePrice={setEditedServiceAndRecalculatePrice}
              itemIdx={itemIdx}
            ></FeeItemSection>
          )}
        </div>
      ))}
      <div className={"pb-1"}>
        <AddPartSection
          editedService={editedService}
          setEditedServiceAndRecalculatePrice={setEditedServiceAndRecalculatePrice}
        ></AddPartSection>
      </div>
    </div>
  );
};
